<div class="reset-password-container">
  <mat-card class="reset-password-card">
    <mat-card-header>
      <mat-card-title>Reset Password</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <!-- Loading State -->
      @if (isLoading) {
      <div class="loading-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p>Validating reset link...</p>
      </div>
      }

      <!-- Error State -->
      @if (errorMessage && !isLoading) {
      <div class="error-container">
        <p class="error-text">{{ errorMessage }}</p>
        <button mat-raised-button color="primary" (click)="goToLogin()">
          Return to login
        </button>
      </div>
      }

      <!-- Success State -->
      @if (successMessage) {
      <div class="success-container">
        <p class="success-text">{{ successMessage }}</p>
        <p class="redirect-text">Redirecting to login page...</p>
      </div>
      }

      <!-- Reset Form -->
      @if (resetRecord && !errorMessage && !successMessage) {
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="reset-form">
        <!-- Password Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your new password" [disabled]="isSubmitting" />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <!-- Confirm Password Field -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm New Password</mat-label>
          <input matInput type="password" formControlName="confirmPassword"
            placeholder="Confirm your new password" [disabled]="isSubmitting" />
        </mat-form-field>

        <!-- Password Requirements -->
        <div class="password-requirements">
          <h4>Password Requirements:</h4>
          <ul>
            <li>At least 8 characters long</li>
            <li>At least one upper case character</li>
            <li>At least one lower case character</li>
            <li>At least one numeric digit</li>
            <li>At least one special character</li>
            <li>No blank spaces</li>
          </ul>
        </div>

        <!-- Form Error -->
        @if (errorMessage) {
        <div class="form-error">
          <p class="error-text">{{ errorMessage }}</p>
        </div>
        }

        <!-- Action Buttons -->
        <div class="form-actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="resetPasswordForm.invalid || isSubmitting"
            class="submit-button">
            {{ isSubmitting ? 'Resetting...' : 'Reset password' }}
          </button>

          <button mat-button type="button" (click)="goToLogin()" [disabled]="isSubmitting" class="cancel-button">
            Cancel
          </button>
        </div>

        <!-- Loading Progress -->
        @if (isSubmitting) {
        <mat-progress-bar mode="indeterminate" class="submit-progress"></mat-progress-bar>
        }
      </form>
      }
    </mat-card-content>
  </mat-card>
</div>